import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  StyledContactInfoContainer,
  StyledContactInfoContent,
  StyledLinkButton,
} from "../styles";
import { ContactInfoForm } from "./form";
import {
  StyledCheckoutComponent,
  StyledHeaderText,
  StyledStepContent,
  StyledStepHeader,
} from "@/components/checkout/uielements";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import { useSelector } from "@/redux";
import meActions from "@/redux/me/actions";
import { phoneNumberFormatter } from "@/utils/auth";
import { fireGaEvent, gaActions, gaCats } from "@/utils/googleAnalytics";

export const ContactInformation = () => {
  const dispatch = useDispatch();
  const [isFormOpened, setIsFormOpened] = useState(false);
  const me = useSelector((root) => root.app.me.data);
  const webConfig = useSelector((root) => root.app.cmsConfig.webConfig);
  const zipCodeEnabled = webConfig.accounts.zip_code !== "disabled";

  useEffect(() => {
    if (!me) {
      dispatch(meActions.fetchMe());
    }
  }, [me]);

  return (
    <StyledCheckoutComponent>
      <StyledStepHeader enabled={true}>
        <StringAccessor
          accessor="account.contact_info_header"
          tag={StyledHeaderText}
        />
      </StyledStepHeader>

      {isFormOpened ? (
        <StyledStepContent enabled={true}>
          <ContactInfoForm close={() => setIsFormOpened(false)} />
        </StyledStepContent>
      ) : (
        <StyledContactInfoContainer>
          <StyledContactInfoContent>
            <div>
              <p>
                {me?.first_name} {me?.last_name}
              </p>
              {me?.email && <p>{me.email}</p>}
              {me?.phone && <p>{phoneNumberFormatter(me.phone)}</p>}
              {zipCodeEnabled && me?.zip_code && <p>{me.zip_code}</p>}
            </div>
            <StyledLinkButton
              onClick={() => {
                setIsFormOpened(true);
                fireGaEvent(gaCats.account, gaActions.editContactInfo);
              }}
              bold={true}
              aria-label="Click to edit personal info"
            >
              <StringAccessor accessor="account.contact_info_edit_button" />
            </StyledLinkButton>
          </StyledContactInfoContent>
        </StyledContactInfoContainer>
      )}
    </StyledCheckoutComponent>
  );
};
